module.exports = __webpack_public_path__ + "img/maison26.33f8a9af.jpg";